import React from 'react';
import { FaLock, FaRocket } from 'react-icons/fa';
import PageHeader from '../../components/PageHeader/PageHeader';
import './Sales.css';

const Sales = () => {
  return (
    <div className="page-shell">
      <PageHeader
        icon={<FaRocket size={22} />}
        title="Sales"
        subtitle="Sales operations module"
      />
      <div className="sales-center">
      <div className="text-center">
        <div className="mb-4">
          <FaRocket size={80} className="sales-rocket" />
        </div>
        <div className="card border-0 shadow-lg p-5 sales-card">
          <div className="badge bg-warning text-dark mb-3 d-inline-block">
            <FaLock className="me-2" />
            Coming Soon
          </div>
          <h2 className="mb-3 fw-bold">Sales Module</h2>
          <p className="text-muted mb-4">
            We're working on something amazing! The Sales module will be launching soon with powerful features to manage your sales operations.
          </p>
          <div className="alert alert-info mb-0" role="alert">
            <strong>Stay tuned!</strong> Check back soon for updates.
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default Sales;
